export default "__VITE_ASSET__DB4LdKL7__"